import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "mh"
};
const _hoisted_2 = {
  class: "mh-left"
};
const _hoisted_3 = {
  key: 0,
  class: "mh-title"
};
const _hoisted_4 = {
  class: "mfoot"
};
import { computed } from "vue";
export default /*@__PURE__*/Object.assign({
  name: "CompetitionDialog"
}, {
  __name: 'CompetitionDialog',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    closeOnClickMask: {
      type: Boolean,
      default: false
    },
    width: {
      type: [Number, String],
      default: "400px"
    },
    title: String,
    subtitle: String
  },
  emits: ["update:modelValue", "close", "submit"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const widthComputed = computed(() => {
      return typeof props.width === "number" ? props.width + "px" : props.width;
    });

    // const open = () => {
    //   emit("open");
    // };

    const close = () => {
      emit("update:modelValue", false);
      emit("close");
    };
    const cliskMask = () => {
      if (!props.closeOnClickMask) return;
      close();
    };
    const submit = () => {
      emit("submit");
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["modal-bg", {
          show: __props.modelValue
        }]),
        onClick: _withModifiers(cliskMask, ["self"])
      }, [_createElementVNode("div", {
        class: "modal",
        style: _normalizeStyle({
          width: widthComputed.value
        })
      }, [_renderSlot(_ctx.$slots, "header", {}, () => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [__props.title ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.title), 1)) : _createCommentVNode("", true)]), _createElementVNode("button", {
        class: "mx",
        onClick: close
      }, "✕")])]), _renderSlot(_ctx.$slots, "default"), _renderSlot(_ctx.$slots, "footer", {}, () => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
        size: "large",
        onClick: close
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode("取 消", -1)]))]),
        _: 1
      }), _createVNode(_component_el_button, {
        size: "large",
        type: "primary",
        onClick: submit
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("确 认", -1)]))]),
        _: 1
      })])])], 4)], 2);
    };
  }
});